import React from "react";
import { Route, useHistory, useLocation } from "react-router-dom";
import { RouteNames } from "common/routing";
import { LoginLocationState } from "../../utils/params";
import { useRedirectParamParser } from "../../utils/params";
import FullPageLoadingScreen from "../Common/FullPageLoadingScreen";
import { MainRouteProps } from "../types";

export const UnauthedRoute = <
  T extends MainRouteProps & { routeName: RouteNames },
>(
  props: T,
) => {
  const { user, admin, routeName } = props;

  const location = useLocation<LoginLocationState>();
  const history = useHistory();

  const fallbackPath = admin ? "/admin/accounts" : "/map";

  const redirectPath = useRedirectParamParser({
    routeName,
    routerLocation: location,
    fallbackPath,
  });

  if (user) {
    history.push(redirectPath);
    return <FullPageLoadingScreen />;
  }

  if (admin) {
    history.push(redirectPath);
    return <FullPageLoadingScreen />;
  }

  return <Route {...props} />;
};
